export default __webpack_public_path__ + "static/media/bg-curve-plan.68f39723.svg";